import zSearch from './src/main.vue';
zSearch.install = (Vue) => {
	Vue.component(zSearch.name, zSearch);
};
export default zSearch;
